/* as.if.records - Startseite 2026 (sections/asif-home.liquid), 23.09.2026.
   - Bereichsleiste: markiert das Kapitel im Blick und scrollt weich (ausser
     bei reduzierter Bewegung). Play und Eintauchen besitzt die Buehne selbst
     (asif-radio-widget.js).
   - Video bei .spaces laedt erst in Sichtweite, nie bei reduzierter Bewegung
     oder Datensparmodus, und laesst sich anhalten.
   SPA-Vertrag: mount() ist idempotent, Aufraeumen bei asif:page:unload und
   shopify:section:unload. Globale Listener nur einmal. */
(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mounts = window.__asifHomeMounts || new Map();
  window.__asifHomeMounts = mounts;

  /* --- Farbaura der Buehne (Pierre 24.09.2026) ----------------------------
     Die Buehne nimmt den Farbton der laufenden Sendung (Sendungsfarbe aus
     asif-radio-widget.js) und setzt daraus vier Toene mit fester Helligkeit
     und Buntheit in OKLCH. So passt jede Sendung zu den Kapitelfarben der
     Seite, egal welchen Ton sie mitbringt. Werte als Hex, damit auch aeltere
     Browser sie lesen. Die letzte Farbe merkt sich der Browser fuer den
     naechsten Aufruf, dann steht die Buehne sofort richtig. */
  const AURA_KEY = 'asif_home_aura_hue_v3';
  const AURA_DEFAULT_HUE = 80;
  const toLinear = (value) => (value <= 0.04045 ? value / 12.92 : ((value + 0.055) / 1.055) ** 2.4);
  const toGamma = (value) => (value <= 0.0031308 ? 12.92 * value : 1.055 * value ** (1 / 2.4) - 0.055);
  const hueOf = (hex) => {
    const match = /^#?([0-9a-f]{6})$/i.exec(String(hex || '').trim());
    if (!match) return null;
    const [r, g, b] = [0, 2, 4].map((i) => toLinear(parseInt(match[1].slice(i, i + 2), 16) / 255));
    const l = Math.cbrt(0.4122214708 * r + 0.5363325363 * g + 0.0514459929 * b);
    const m = Math.cbrt(0.2119034982 * r + 0.6806995451 * g + 0.1073969566 * b);
    const s = Math.cbrt(0.0883024619 * r + 0.2817188376 * g + 0.6299787005 * b);
    const a = 1.9779984951 * l - 2.4285922050 * m + 0.4505937099 * s;
    const bb = 0.0259040371 * l + 0.7827717662 * m - 0.8086757660 * s;
    return (Math.atan2(bb, a) * 180 / Math.PI + 360) % 360;
  };
  const oklchHex = (L, C, h) => {
    for (let chroma = C; chroma >= 0; chroma -= 0.002) {
      const a = chroma * Math.cos(h * Math.PI / 180);
      const b = chroma * Math.sin(h * Math.PI / 180);
      const l = (L + 0.3963377774 * a + 0.2158037573 * b) ** 3;
      const m = (L - 0.1055613458 * a - 0.0638541728 * b) ** 3;
      const s = (L - 0.0894841775 * a - 1.2914855480 * b) ** 3;
      const rgb = [
        4.0767416621 * l - 3.3077115913 * m + 0.2309699292 * s,
        -1.2684380046 * l + 2.6097574011 * m - 0.3413193965 * s,
        -0.0041960863 * l - 0.7034186147 * m + 1.7076147010 * s
      ];
      if (rgb.every((v) => v >= -0.0001 && v <= 1.0001) || chroma < 0.002) {
        return `#${rgb.map((v) => Math.round(Math.min(1, Math.max(0, toGamma(v))) * 255).toString(16).padStart(2, '0')).join('')}`;
      }
    }
    return '#f2efe6';
  };
  let auraHue = null;
  const AURA_FAMILIES = [25, 55, 155, 200, 259, 320];
  const snapHue = (hue) => {
    const h = ((hue % 360) + 360) % 360;
    let best = AURA_FAMILIES[0];
    let bestDistance = 360;
    AURA_FAMILIES.forEach((family) => {
      const distance = Math.min(Math.abs(h - family), 360 - Math.abs(h - family));
      if (distance < bestDistance) { best = family; bestDistance = distance; }
    });
    return best;
  };
  const applyAura = (hue, { instant = false } = {}) => {
    if (!Number.isFinite(hue)) return;
    const rounded = Math.round(hue);
    if (rounded === auraHue) return;
    auraHue = rounded;
    const body = document.body;
    // 24.09. spaet (Pierre, Variante A "Tief"): Die Buehne ist ein tiefer
    // Kapitelton. Der Farbton der Sendung wird auf die naechste Kapitelfamilie
    // gelenkt (Rot, Bernstein, Gruen, Petrol, Blau, Pflaume). Gelb ist fuer
    // Knoepfe und das Magazin reserviert und kommt hier nie vor.
    const family = snapHue(rounded);
    const tones = {
      '--aura-base': oklchHex(0.3, 0.07, family),
      '--aura-1': oklchHex(0.4, 0.11, family + 12),
      '--aura-2': oklchHex(0.36, 0.09, family + 40),
      '--aura-3': oklchHex(0.46, 0.06, family - 30)
    };
    if (instant) body.classList.add('asif-aura-instant');
    Object.entries(tones).forEach(([name, value]) => body.style.setProperty(name, value));
    body.dataset.auraBase = tones['--aura-base'];
    const meta = document.querySelector('meta[data-asif-theme-color]');
    if (meta && body.classList.contains('asif-home') && !document.documentElement.dataset.asifRadioMode) meta.content = tones['--aura-base'];
    if (instant) window.requestAnimationFrame(() => window.requestAnimationFrame(() => body.classList.remove('asif-aura-instant')));
    try { localStorage.setItem(AURA_KEY, String(rounded)); } catch (error) {}
  };
  const auraFromState = (state) => {
    if (!state || !document.body.classList.contains('asif-home')) return;
    const now = Date.now();
    const slot = (state.schedule || []).find((item) => Date.parse(item?.startsAt) <= now && Date.parse(item?.endsAt) > now);
    const programmes = window.AsIfRadioProgrammes;
    const color = slot && programmes?.profileFor ? programmes.profileFor(slot).color : '';
    const hue = hueOf(color);
    if (hue !== null) applyAura(hue);
    else if (auraHue === null && state.scheduleStatus && !['idle', 'loading'].includes(state.scheduleStatus)) applyAura(AURA_DEFAULT_HUE);
    const stage = document.querySelector('.home [data-stage-aura]');
    if (stage) stage.closest('.stage')?.classList.add('has-aura');
  };
  const startAura = () => {
    if (!document.body.classList.contains('asif-home')) return;
    if (auraHue === null) {
      let cached = NaN;
      try { cached = Number(localStorage.getItem(AURA_KEY)); } catch (error) {}
      if (Number.isFinite(cached) && localStorage.getItem(AURA_KEY) !== null) {
        applyAura(cached, { instant: true });
        document.querySelector('.home [data-stage-aura]')?.closest('.stage')?.classList.add('has-aura');
      }
    }
    auraFromState(window.AsIfRadio?.getState?.());
  };



  const mount = (root) => {
    if (!root || mounts.has(root)) return;
    const cleanups = [];
    let spyFrame = 0;
    mounts.set(root, () => {
      window.cancelAnimationFrame(spyFrame);
      cleanups.splice(0).forEach((cleanup) => cleanup());
      mounts.delete(root);
    });
    const listen = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      cleanups.push(() => target.removeEventListener(type, handler, options));
    };

    /* --- Aura: steht still, solange die Buehne nicht im Bild ist ----------- */
    const auraStage = root.querySelector('[data-stage-aura]')?.closest('.stage');
    if (auraStage && 'IntersectionObserver' in window) {
      const auraObserver = new IntersectionObserver((entries) => {
        auraStage.classList.toggle('is-aura-still', !entries.some((entry) => entry.isIntersecting));
      });
      auraObserver.observe(auraStage);
      cleanups.push(() => auraObserver.disconnect());
    }
    startAura();

    /* --- Bereichsleiste ---------------------------------------------------- */
    const nav = root.querySelector('[data-home-nav]');
    const links = nav ? [...nav.querySelectorAll('[data-home-nav-link]')] : [];
    const targets = links.map((link) => document.getElementById(link.hash.slice(1))).filter(Boolean);
    let current = '';
    const setCurrent = (id) => {
      if (id === current) return;
      current = id;
      links.forEach((link) => {
        const active = link.hash === `#${id}`;
        if (active) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
        if (active && link.parentElement && link.parentElement.scrollWidth > link.parentElement.clientWidth) {
          const track = link.parentElement;
          const left = link.offsetLeft - (track.clientWidth - link.offsetWidth) / 2;
          track.scrollTo({ left: Math.max(0, left), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
        }
      });
    };
    const spy = () => {
      window.cancelAnimationFrame(spyFrame);
      spyFrame = window.requestAnimationFrame(() => {
        const line = window.innerHeight * 0.38;
        let active = targets[0]?.id || '';
        targets.forEach((target) => { if (target.getBoundingClientRect().top <= line) active = target.id; });
        // Nach dem letzten Kapitel (Social, Footer) ist nichts mehr markiert.
        const last = targets[targets.length - 1];
        if (last && last.getBoundingClientRect().bottom < line) active = '';
        setCurrent(active);
      });
    };
    if (targets.length) {
      listen(window, 'scroll', spy, { passive: true });
      listen(window, 'resize', spy, { passive: true });
      spy();
    }
    links.forEach((link) => listen(link, 'click', (event) => {
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      const behavior = reduceMotion.matches ? 'auto' : 'smooth';
      if (link.hash === '#radio') window.scrollTo({ top: 0, behavior });
      else target.scrollIntoView({ behavior, block: 'start' });
      history.replaceState(history.state, '', link.hash === '#radio' ? window.location.pathname + window.location.search : link.hash);
      setCurrent(target.id);
    }));

    /* --- .studio: Aufnahme-Anzeige (laeuft mit dem stummen Video) ----------- */
    root.querySelectorAll('.home-place--studio [data-home-media]').forEach((figure) => {
      const video = figure.querySelector('video');
      const rec = figure.querySelector('[data-home-rec]');
      const recTime = figure.querySelector('[data-home-rec-time]');
      if (!video || !rec) return;
      let last = -1;
      listen(video, 'timeupdate', () => {
        const t = Math.floor(video.currentTime || 0);
        if (t === last || !recTime) return;
        last = t;
        recTime.textContent = `${String(Math.floor(t / 60)).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
      });
      listen(video, 'playing', () => { rec.hidden = false; });
      listen(video, 'pause', () => { rec.hidden = true; });
    });

    /* --- .shop: Likoer direkt in den Warenkorb -------------------------------- */
    root.querySelectorAll('[data-home-buy]').forEach((form) => {
      const button = form.querySelector('[data-home-buy-btn]');
      const label = form.querySelector('[data-home-buy-label]');
      const status = form.closest('.home-feature')?.querySelector('[data-home-buy-status]');
      const priceOut = form.querySelector('[data-home-buy-price]');
      form.querySelectorAll('input[type="radio"][name="id"]').forEach((radio) => listen(radio, 'change', () => {
        if (priceOut && radio.checked) priceOut.textContent = ` · ${radio.dataset.price}`;
        button?.classList.remove('is-done');
        if (label) label.textContent = 'In den Warenkorb';
      }));
      listen(form, 'submit', async (event) => {
        event.preventDefault();
        if (!button || button.getAttribute('aria-busy') === 'true') return;
        button.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
          });
          const data = await response.json();
          if (!response.ok) throw new Error(data?.description || 'Fehler');
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          button.classList.add('is-done');
          if (label) label.textContent = 'Im Warenkorb';
          if (status) status.innerHTML = 'Liegt im Warenkorb. <a href="/cart">Zum Warenkorb</a>';
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.show === 'function') window.setTimeout(() => drawer.show(), 350);
        } catch (error) {
          if (status) status.textContent = 'Das hat nicht geklappt. Bitte über „Mehr zum Likör“ bestellen.';
        } finally {
          button.removeAttribute('aria-busy');
        }
      });
    });

    /* --- .shop: Bildergalerie in den Merch-Karten ------------------------------
       Kein Scrollbereich (sonst per Tastatur nicht erreichbar), sondern eine
       Bahn, die per Wischen oder Mauszeiger ein Bild weiter rueckt. */
    root.querySelectorAll('[data-home-gallery]').forEach((gallery) => {
      const slides = gallery.querySelector('.home-product__slides');
      const dots = [...gallery.querySelectorAll('.home-product__dots i')];
      const count = slides ? slides.children.length : 0;
      if (!slides || count < 2) return;
      const card = gallery.closest('a');
      let index = 0;
      const show = (next) => {
        index = (next + count) % count;
        slides.style.setProperty('--slide', String(index));
        dots.forEach((dot, k) => dot.classList.toggle('is-on', k === index));
      };
      let startX = null;
      let startY = null;
      let swiped = false;
      listen(gallery, 'pointerdown', (event) => { if (event.pointerType === 'mouse') return; startX = event.clientX; startY = event.clientY; swiped = false; });
      listen(gallery, 'pointerup', (event) => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        const dy = event.clientY - startY;
        startX = null;
        if (Math.abs(dx) > 30 && Math.abs(dx) > Math.abs(dy)) { swiped = true; show(index + (dx < 0 ? 1 : -1)); }
      });
      listen(gallery, 'pointercancel', () => { startX = null; });
      if (card) {
        listen(card, 'click', (event) => { if (swiped) { event.preventDefault(); swiped = false; } });
        const fine = window.matchMedia('(hover: hover) and (pointer: fine)');
        listen(card, 'pointerenter', () => { if (fine.matches) show(1); });
        listen(card, 'pointerleave', () => { if (fine.matches) show(0); });
      }
    });

    /* --- Videos: .spaces, .spirits, .studio, Likoer ------------------------- */
    const saveData = navigator.connection?.saveData === true;
    root.querySelectorAll('[data-home-video]').forEach((video) => {
      const toggle = video.parentElement.querySelector('[data-home-video-toggle]');
      const label = toggle?.querySelector('[data-home-video-label]');
      if (reduceMotion.matches || saveData || !('IntersectionObserver' in window)) return;
      let userPaused = false;
      let visible = false;
      const syncToggle = () => {
        if (!toggle) return;
        toggle.dataset.state = video.paused ? 'paused' : 'playing';
        if (label) label.textContent = video.paused ? 'Video abspielen' : 'Video anhalten';
      };
      listen(video, 'play', syncToggle);
      listen(video, 'pause', syncToggle);
      const load = () => {
        if (video.src) return;
        const small = window.matchMedia('(max-width: 699px)').matches;
        const source = (small && video.dataset.mobileSrc) || video.dataset.src;
        if (!source) return;
        video.preload = 'metadata';
        video.src = source;
        video.addEventListener('loadeddata', () => {
          video.classList.add('is-ready');
          if (toggle) toggle.hidden = false;
          syncToggle();
          if (visible && !userPaused) video.play().catch(syncToggle);
        }, { once: true });
      };
      // Laden kurz bevor das Video ins Bild kommt, abspielen nur, solange es
      // wirklich zu sehen ist. So laeuft nie ein Video ausserhalb des Bildes.
      const loader = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) { load(); loader.disconnect(); }
      }, { rootMargin: '600px 0px' });
      loader.observe(video);
      const observer = new IntersectionObserver((entries) => {
        visible = entries.some((entry) => entry.isIntersecting);
        if (!video.src) return;
        if (visible && !userPaused && !document.hidden) video.play().catch(syncToggle);
        else video.pause();
      }, { threshold: 0.15 });
      observer.observe(video);
      cleanups.push(() => { loader.disconnect(); observer.disconnect(); });
      if (toggle) listen(toggle, 'click', () => {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else video.play().catch(syncToggle);
      });
      const onReduce = () => { if (reduceMotion.matches) { userPaused = true; video.pause(); } };
      listen(reduceMotion, 'change', onReduce);
    });

  };

  const mountAll = () => document.querySelectorAll('[data-asif-home]').forEach(mount);
  const unmountDetached = () => mounts.forEach((cleanup, root) => { if (!root.isConnected) cleanup(); });

  if (!window.__asifHomeGlobal) {
    window.__asifHomeGlobal = true;
    document.addEventListener('asif:page', () => { unmountDetached(); mountAll(); });
    window.addEventListener('asif:radio-state', (event) => auraFromState(event.detail));
    window.addEventListener('asif:radio-ready', (event) => auraFromState(event.detail));
    document.addEventListener('asif:page:unload', () => mounts.forEach((cleanup) => cleanup()));
    document.addEventListener('shopify:section:load', mountAll);
    document.addEventListener('shopify:section:unload', (event) => {
      mounts.forEach((cleanup, root) => { if (event.target.contains(root)) cleanup(); });
    });
  }
  mountAll();
})();
